import { take, fork, select, put, call, delay } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import config from '../../config/config';
import {getCurrentClubId, getGlobalToken} from '../selectors';
import {showNotification} from "../actionCreators/notification";
import {updateLevelSuccess} from "../actionCreators/clubLevel";

function* updateClubLevel({ level }) {
    try {
        const token = yield select(getGlobalToken);
        const clubId = yield select(getCurrentClubId);
        yield call(callApi, `${config.API_URL}/club/account/${clubId}/level`, 'PATCH', { level, token });

        yield put(updateLevelSuccess());
        yield put(showNotification({message: `Successfully updated the level of club.`}));
    } catch (e) {}
}

export function* watchClubLevelUpdate() {
    while (true) {
        const action = yield take(actionTypes.UPDATE_LEVEL_REQUEST);
        yield fork(updateClubLevel, action);
    }
}
